import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/seo-articles';

export default function SeoArticleSection() {
  return (
    <section id="seo-articles" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold uppercase tracking-wider mb-5">
            Latest Guides
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 tracking-tight max-w-3xl mx-auto leading-tight">
            VigorBuy Sheet Guides &amp; Resources
          </h2>
          <p className="mt-5 text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Explore our collection of in-depth guides covering everything from beginner tutorials to advanced buying strategies for smarter shopping with the VigorBuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/seo/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden hover:bg-background-50/80 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  title={article.title}
                />
              </div>
              <div className="p-5">
                <div className="flex flex-wrap items-center gap-2 mb-3">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-[10px] font-semibold uppercase tracking-wider"
                    >
                      {tag}
                    </span>
                  ))}
                  <span className="text-[11px] text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 tracking-tight leading-snug group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-xs font-semibold text-primary-600 whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-base"></i>
            Visit Main Store
          </a>
        </div>
      </div>
    </section>
  );
}